export default __webpack_public_path__ + "static/media/worst-truck.030f2012.png";